import { render, staticRenderFns } from "./AttachmentsDialog.vue?vue&type=template&id=7d12f025&scoped=true&"
import script from "./AttachmentsDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d12f025",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d12f025')) {
      api.createRecord('7d12f025', component.options)
    } else {
      api.reload('7d12f025', component.options)
    }
    module.hot.accept("./AttachmentsDialog.vue?vue&type=template&id=7d12f025&scoped=true&", function () {
      api.rerender('7d12f025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/AttachmentsDialog.vue"
export default component.exports